export const TAG_VALUES_LIMIT = 10

export enum OpenState {
  UNOPENED = 'unopened',
  OPENED = 'opened',
  ClOSED = 'closed',
}
